import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PagoService } from 'src/app/services/pago.service';
import { SaldoDocumentoService } from 'src/app/services/saldo-documento.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalViewDetailsPagoComponent } from 'src/app/views/cta-cte-cliente/cartola-cliente/modal-view-details-pago/modal-view-details-pago.component';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalFoliosLiquidacionComponent } from '../modal-folios-liquidacion/modal-folios-liquidacion.component';


@Component({
  selector: 'app-pagos-cliente-docs-ctas',
  templateUrl: './docs-ctas.component.html',
  styleUrls: ['./docs-ctas.component.scss'],
  providers: [SecurityService],
})
export class DocsCtasComponent implements OnInit {
  @Output() onConformeAbono: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLoadDetailsSuccess: EventEmitter<void> = new EventEmitter<void>();
  @Output() onObtenerSaldoDocumentoError: EventEmitter<void> = new EventEmitter<void>();

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ModalViewDetailsPagoComponent, { static: true }) modalVerPago: ModalViewDetailsPagoComponent
  @ViewChild(ModalFoliosLiquidacionComponent, { static: true }) modalFoliosLiquidacion: ModalFoliosLiquidacionComponent;

  // Form
  formDocs: FormGroup;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  clienteSeleccionado: any;
  clienteSeleccionadoVendedor: any;
  enabled: boolean = false;
  enabledMaster: boolean = false;
  vendedor_codigo: any = null;
  esTipoDeclaranteVendedor: any = null;
  documentosPendientes: Array<any> = null;
  documentosPendientesTotales: any = {
    total_monto: 0,
    total_pago: 0,
    total_abono: 0,
    total_deuda: 0,
  };
  pagosACuentas: Array<any> = null;
  pagosACuentasTotales: any = {
    total_pago_cuenta: 0,
    total_pago_cuenta_utilizado: 0,
    diferencial_pagar: 0,
  };

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private saldoDocumentoService: SaldoDocumentoService,
    private rutService: RutService,
    private pagoService: PagoService
  ) {
    this.log = this.clog.log('REALIZAR-PAGOS-DOCTOS-CTAS');
  }

  /** Deshabilita el botón cuando el diferencial a pagar es negativo. Si no hay totales o no hay valor, se deshabilita por seguridad. */
  get disableBtnMontoConforme() {
    if (!this.pagosACuentasTotales) return true;
    const val = this.pagosACuentasTotales.diferencial_pagar;
    return val == null ? true : Number(val) < 0;
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.createForms();
    this.formChangesSubscriptions();

    // TODO: DELETE ME!! ONLY FOR DEV PURPOSES
    // this.loadData(0, false, 26230691);
  }

  private createForms() {
    this.formDocs = this.fb.group({
      rutDeclarante: ['', [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formDocs
      .get('rutDeclarante')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutDeclarante: string) => {
        this.modalSeleccionarCliente.searchByRut(rutDeclarante);
      });
  }

  public loadData(vendedor_codigo, esTipoDeclaranteVendedor, cliente_proveedor_rut, clienteSeleccionadoVendedor) {
    this.vendedor_codigo = vendedor_codigo;
    this.esTipoDeclaranteVendedor = esTipoDeclaranteVendedor;
    this.clienteSeleccionadoVendedor = clienteSeleccionadoVendedor;
    this.enabledMaster = true;
    if (!esTipoDeclaranteVendedor) {
      this.obtenerSaldoDocumentoCliente(cliente_proveedor_rut);
    }
  }

  obtenerSaldoDocumentoCliente(cliente_proveedor_rut) {
    this.saldoDocumentoService.obtenerSaldoDocumentoCliente(Number(this.rutEmpresa), Number(this.sucursalEmpresa), cliente_proveedor_rut, false, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      // const ok = respuesta !== null
      // if (!ok) {
      //   this.messageRendererService.showErrors(mensajes)
      //   return
      // }
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.clearData();
        this.onObtenerSaldoDocumentoError.emit();
        return;
      }

      const okInfo = mensajes.filter((m) => (m.tipo = 'INFO')).length === 0;
      if (!okInfo) {
        this.messageRendererService.showInfoMessages(mensajes);
        // return
      }
      this.documentosPendientes = registros;
      this.documentosPendientes.map((docto) => {
        docto.seleccion = false;
        docto.abono = 0;
        docto.deuda = Number(docto.deuda.toString().replace(/\./g, ''))
        docto.pago = Number(docto.pago.toString().replace(/\./g, ''))
        docto.saldo = Number(docto.saldo.toString().replace(/\./g, ''))


      });

      this.obtenerPagoAcuenta(cliente_proveedor_rut, true);
    });
  }

  obtenerPagoAcuenta(cliente_proveedor_rut, emitSuccess: boolean = false) {
    this.pagoService.obtenerPagoAcuenta(Number(this.rutEmpresa), Number(this.sucursalEmpresa), cliente_proveedor_rut, true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.pagosACuentas = registros;
      this.pagosACuentas.map((pago, index) => {
        pago.seleccion = false;
        pago.index = index;
        // pago.pago_cuenta_utilizado = pago.tipo_pago_cuenta_codigo === 1 ? pago.saldo : 0
        pago.pago_cuenta_utilizado = 0;
      });
      if (emitSuccess) this.onLoadDetailsSuccess.emit();

      this.enabled = true;
    });
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show();
  }

  onClienteByVendedorSeleccionado({ data: cliente }) {
    // limpiar
    this.documentosPendientes = null;
    this.pagosACuentas = null;
    this.enabled = false;

    this.clienteSeleccionado = cliente;
    const { rut } = cliente;
    this.formDocs.get('rutDeclarante').setValue(this.rutService.AgregarDV(this.clienteSeleccionado.rut));
    this.obtenerSaldoDocumentoCliente(rut);
    // this.obtenerPagoAcuenta(rut)
    // this.enabled = true
  }

  onClienteByVendedorNoEncontrado() {
    this.clienteSeleccionado = null;
    this.enabled = false;
    this.clearListas();
  }

  checkAllDocPendientesChange({ checked }) {
    this.documentosPendientes.forEach((doc) => {
      doc.seleccion = checked;
      this.setValorAbonoDocumento(doc);
    });
    this.obtenerTotalSaldoDocumentoCliente();
  }

  checkDocPendiente({ codigo }) {
    const selected = this.documentosPendientes.filter((doc) => doc.codigo === codigo)[0];
    selected.seleccion = !selected.seleccion;
    this.setValorAbonoDocumento(selected);
    this.obtenerTotalSaldoDocumentoCliente();
  }

  setValorAbonoDocumento(documento) {
    if (documento.seleccion) {
      if (documento.abono === 0) documento.abono = documento.deuda;
    } else {
      documento.abono = 0;
    }
  }

  doctoAbonoChange({ target }) {
    const { value } = target;
    this.obtenerTotalSaldoDocumentoCliente();
  }

  obtenerTotalSaldoDocumentoCliente() {
    this.documentosPendientes.forEach((docto) => {
      if (!docto.abono) docto.abono = '0';
      docto.abono = Number(docto.abono.toString().replace(/\./g, ''));
    });

    const saldoDocumento = this.documentosPendientes.filter((doc) => doc.seleccion);
    saldoDocumento.map((docto) => {
      delete docto.__typename;
    });
    const inputParams = {
      entidad: {
        saldoDocumento,
      },
    };
    this.saldoDocumentoService.obtenerTotalSaldoDocumentoCliente(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.documentosPendientesTotales = respuesta;
      this.obtenerTotalDiferencialUtilizado();
      this.documentosPendientes.forEach((docto) => {
        //  console.log("muestrame el abono ",docto.abono);
        if (docto.abono > 0) {
          docto.abono = docto.abono.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }
      });
    });
  }

  checkAllPagosACuenta({ checked }) {
    this.pagosACuentas.forEach((pago) => {
      pago.seleccion = checked;
      // Si está checkeado, asignar el saldo, si no, asignar 0
      pago.pago_cuenta_utilizado = checked ? pago.saldo : 0;
    });
    this.obtenerTotalDiferencialUtilizado();
  }


  checkPagoACuenta({ index }) {
    const selected = this.pagosACuentas.filter((pago) => pago.index === index)[0];
    selected.seleccion = !selected.seleccion;

    if (selected.tipo_pago_cuenta_codigo === 2) {
      selected.pago_cuenta_utilizado = 0;
      if (selected.seleccion) selected.pago_cuenta_utilizado = selected.saldo;
    }
    if (selected.tipo_pago_cuenta_codigo === 3) {
      selected.pago_cuenta_utilizado = 0;
      if (selected.seleccion) selected.pago_cuenta_utilizado = selected.saldo;
    }

    this.setValorAbonoPagoACuenta(selected);
    this.obtenerTotalDiferencialUtilizado();
  }

  setValorAbonoPagoACuenta(pago) {
    if (pago.seleccion) {
      if (pago.pago_cuenta_utilizado === 0) pago.pago_cuenta_utilizado = pago.saldo;
    } else {
      pago.pago_cuenta_utilizado = 0;
    }

  }

  pagoCuentaUtilizadoChange({ target }) {
    const { value } = target;
    const pago = this.pagosACuentas.find(p => p.pago_cuenta_utilizado === value);

    if (pago && Number(value) > this.documentosPendientesTotales.total_abono) {
      this.toastrService.error('El monto del pago a cuenta no puede ser mayor que el abono total');
      pago.pago_cuenta_utilizado = 0;
      return;
    }

    this.obtenerTotalDiferencialUtilizado();
  }

  obtenerTotalDiferencialUtilizado() {
    const inputParams = this.getInputParamsDiferenciasYSaldos();
    this.pagoService.obtenerTotalDiferencialUtilizado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.pagosACuentasTotales = respuesta;
    });
  }

  getInputParamsDiferenciasYSaldos() {
    const difereciaPago = _.cloneDeep(this.pagosACuentas).filter((pago) => pago.seleccion);
    difereciaPago.map((docto) => {
      delete docto.__typename;
      delete docto.index;
    });
    const saldoDocumento = _.cloneDeep(this.documentosPendientes).filter((doc) => doc.seleccion);
    saldoDocumento.map((docto) => {
      delete docto.__typename;
      docto.abono = Number(docto.abono.toString().replace(/\./g, ''));
    });

    return {
      entidad: {
        difereciaPago,
        saldoDocumento,
      },
    };
  }

  async conformeAbono() {
    if (!this.enabled) {
      this.toastrService.error('Deshabilitado');
      return;
    }

    // Validar que ningún pago a cuenta o excedente sea mayor que el abono total
    const hayPagoACuentaMayor = this.pagosACuentas.some(pago =>
      pago.seleccion && pago.tipo_pago_cuenta_codigo === 1 && Number(pago.pago_cuenta_utilizado) > this.documentosPendientesTotales.total_abono
    );

    const hayExcedenteMayor = this.pagosACuentas.some(pago =>
      pago.seleccion && pago.tipo_pago_cuenta_codigo === 3 && Number(pago.pago_cuenta_utilizado) > this.documentosPendientesTotales.total_abono
    );

    if (hayPagoACuentaMayor && hayExcedenteMayor) {
      this.toastrService.error('No puede continuar. Existe un pago a cuenta y un excedente mayor al abono total');
      return;
    } else if (hayPagoACuentaMayor) {
      this.toastrService.error('No puede continuar. Existe un pago a cuenta mayor que el abono total');
      return;
    } else if (hayExcedenteMayor) {
      this.toastrService.error('No puede continuar. Existe un excedente mayor que el abono total');
      return;
    }

    //TODO: VALIDAR QUE NO HAYA ABONO DE DOCUMENTOS EN LA LIQUIDACION.
    //TODO: SI ES ASI, MOSTRAR UN MODAL CON LOS FOLIOS DE LA LIQUIDACION.


    // Validar folios en liquidación antes de proceder
    const validacionExitosa = await this.validarFoliosEnLiquidacion();
    if (!validacionExitosa) {
      return; // Si la validación no es exitosa, no continuar
    }


    const inputParams = this.getInputParamsDiferenciasYSaldos();
    this.pagoService.conformeAbono(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.toastrService.success('Operación realizada');
      delete respuesta.__typename;
      const { diferencial_pagar } = this.pagosACuentasTotales;
      // this.onConformeAbono.emit({ diferencial_pagar, ...respuesta })

      const saldoDocumento = _.cloneDeep(this.documentosPendientes).filter((pago) => pago.seleccion);
      const difereciaPago = _.cloneDeep(this.pagosACuentas).filter((pago) => pago.seleccion);
      saldoDocumento.forEach((pago) => {
        delete pago.__typename;
        pago.abono = Number(pago.abono.toString().replace(/\./g, ''));
      });
      difereciaPago.forEach((pago) => {
        delete pago.__typename;
        delete pago.index;
      });

      this.onConformeAbono.emit({
        monto_coforme: this.pagosACuentasTotales.diferencial_pagar,
        saldoDocumento,
        difereciaPago,
        cliente_proveedor_rut: this.esTipoDeclaranteVendedor ? this.clienteSeleccionado.rut : null,
        habilitarPago: this.pagosACuentasTotales.diferencial_pagar === 0 ? true : false
      });
      this.enabled = false;
    });
  }


  private validarFoliosEnLiquidacion(): Promise<boolean> {
    return new Promise((resolve) => {
      const ParamsLiquidacion = {
        empresa_rut: this.rutEmpresa,
        cliente_proveedor_rut: this.clienteSeleccionadoVendedor.rut,
        documentos: this.documentosPendientes
          .filter((doc) => doc.folio && doc.seleccion === true)
          .map((doc) => ({
            folio: doc.folio,
            cod_recorrido: doc.recorrido_codigo
          }))
      };

      this.pagoService.validarFoliosEnLiquidacion(ParamsLiquidacion, ({ respuesta, mensajes }) => {
        const ok = respuesta !== null;

        const alert = mensajes.length > 0;
        if (alert) {
          this.modalFoliosLiquidacion.NotificarFoliosEnLiquidacion(mensajes);
          resolve(false); // La validación no fue exitosa
        } else {
          resolve(true); // La validación fue exitosa
        }
      });
    });
  }


  clearData() {
    this.enabled = false;
    this.enabledMaster = false;

    this.formDocs.reset();
    this.formDocs.markAsUntouched();
    this.formDocs.markAsPristine();
    this.formDocs.get('rutDeclarante').setValue('');

    this.clienteSeleccionado = null;
    this.vendedor_codigo = null;
    this.esTipoDeclaranteVendedor = null;
    this.clearListas();
  }

  clearListas() {
    this.documentosPendientes = null;
    this.documentosPendientesTotales = {
      total_monto: 0,
      total_pago: 0,
      total_abono: 0,
      total_deuda: 0,
    };
    this.pagosACuentas = null;
    this.pagosACuentasTotales = {
      total_pago_cuenta: 0,
      total_pago_cuenta_utilizado: 0,
      diferencial_pagar: 0,
    };
  }
  loadAndShowDetallePago({ pago_codigo }) {
    const Usuario = this.clienteSeleccionado === undefined || this.clienteSeleccionado === null ? this.clienteSeleccionadoVendedor === null || this.clienteSeleccionadoVendedor === undefined ? 0 : this.clienteSeleccionadoVendedor : this.clienteSeleccionado
    this.modalVerPago.loadAndShow(pago_codigo, Usuario);
  }
}
